import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {User} from '../../model/Entities/User';

@Component({
    selector: 'user-delete-confirm-dialog',
    templateUrl: './user-delete-confirm.dialog.component.html',
    styleUrls: ['./user-delete-confirm.dialog.component.scss']
})
export class UserDeleteConfirmDialogComponent {

    user: User;

    constructor(public dialog: MatDialogRef<UserDeleteConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.user = data.user;
        // super(dialog, data);
    }
}



// WEBPACK FOOTER //
// /app/src/UsersModule/UserDeleteConfirmDialogComponent/user-delete-confirm.dialog.component.ts